// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash'
import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class MeasuringPointService {
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/get-list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async addFolder(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(`/api/std/CollectDataSourceConfig/folder`, payload)
    )
    return Callback(err, res)
  }
  static async updateFolder(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/CollectDataSourceConfig/folder`, payload)
    )
    return Callback(err, res)
  }
  static async deleteTags(payload) {
    // 批量删除测点
    const [err, res] = await To(
      wizStandardInstance(`/api/std/CollectDataSourceConfig/measuringpoint/delete`, {
        method: 'delete',
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async deleteFolder(payload) {
    const [err, res] = await To(
      wizStandardInstance(`/api/std/CollectDataSourceConfig/folder`, {
        method: 'delete',
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async getFolders(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(`/api/std/CollectDataSourceConfig/folder-tree`, payload)
    )
    return Callback(err, res)
  }
  // 导出服务端测点
  static async exportServiceTags(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/server-measuring-point-export?${qs.stringify(
          payload
        )}`,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  static async downloadExportTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/download-template?${qs.stringify(
          payload
        )}`,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  static async addPoint(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(`/api/std/CollectDataSourceConfig/measuringpoint`, payload)
    )
    return Callback(err, res)
  }
  static async updatePoint(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/CollectDataSourceConfig/measuringpoint`, payload)
    )
    return Callback(err, res)
  }
  static async testPoint(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/CollectDataSourceConfig/measuringpoint`, payload)
    )
    return Callback(err, res)
  }
  static async getModbusFunCode() {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/get-modbus-function-code`
      )
    )
    return Callback(err, res)
  }
  static async getIce102FunCode() {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/get-iec102-function-code`
      )
    )
    return Callback(err, res)
  }
  static async getModbusDataType() {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/get-modbus-data-type`
      )
    )
    return Callback(err, res)
  }
  static async import(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(`/api/std/CollectDataSourceConfig/measuringpoint/import`, payload)
    )
    return Callback(err, res)
  }
  static async export(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/CollectDataSourceConfig/measuringpoint/export', payload,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  static async pointDetail(id) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/CollectDataSourceConfig/measuringpoint/${id}`)
    )
    return Callback(err, res)
  }
  static async testPoint(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/test-point?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getServerPointPaged(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/server-measuring-point-list?${qs.stringify(
          payload
        )}`
      )
    )
    return Callback(err, res)
  }
  static async getServerPoint(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/CollectDataSourceConfig/measuringpoint/server-measuring-point`,
        payload
      )
    )
    return Callback(err, res)
  }
  static async switchPointStatus(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/CollectDataSourceConfig/measuringpoint/set-collect-status`,
        payload
      )
    )
    return Callback(err, res)
  }
}
